import styled from 'styled-components';

export const DetailsRowStyled = styled.div`
  display: flex;
  margin-bottom: 16px;
  color: var(--ds-text-subtle, var(--ds-fb-text-subtle));

  &:last-child {
    margin-bottom: 0;
  }
`;

export const DetailsRowLabelStyled = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const DetailsRowValueStyled = styled.div``;

export const DetailsRowValueStyledSpan = styled.div`
  margin-left: 12px;
`;
